import { Avatar, Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BeforeAfterType } from "src/api/types";
import WhiteCard from "src/shared/components/WhiteCard";

interface Props {
  card: BeforeAfterType;
  width?: number | string;
  onNext?: () => void;
}

const BeforeAfterCard = ({ card, width, onNext }: Props) => {
  const { t } = useTranslation();
  const component = "beforeAndAfter";

  return (
    <WhiteCard
      width={width}
      key={card.name}
      onClick={onNext}
      sx={{ backgroundColor: "#F2F2F2" }}
    >
      <Box component="img" src={card.image} width="100%" />
      <Stack direction="row" gap={1}>
        <Avatar src={card.avatar} alt="Before-after-avatar" />
        <Stack>
          <Typography variant="subtitle1" fontWeight={700}>
            {card.name}
          </Typography>
          <Typography variant="subtitle1">
            {t(`${component}.caption`, "Verfied Review")}
          </Typography>
        </Stack>
      </Stack>
    </WhiteCard>
  );
};

export default BeforeAfterCard;
